import { render, staticRenderFns } from "./RiskSignature.vue?vue&type=template&id=7f7dad6f&scoped=true"
import script from "./RiskSignature.vue?vue&type=script&lang=ts&setup=true"
export * from "./RiskSignature.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RiskSignature.vue?vue&type=style&index=0&id=7f7dad6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7dad6f",
  null
  
)

export default component.exports